/* eslint-disable @typescript-eslint/no-use-before-define */
import _ from 'lodash';

import { Location } from 'history';
import { AbExperiment, ABTestEnum, ArticleTypes } from './types';

import { ARTICLE_TYPES } from './article-utils';
import { ArticleTypeEnum } from '~/generated-gql/generated-types';

const config: { [key in ABTestEnum]: AbExperiment } = {
  // This is an example and is not a real, active test
  [ABTestEnum.EXAMPLE_AB_TEST]: {
    id: 'articles_example_ab',
    control: 'control',
    variant: 'variant',
    urls: [
      {
        path: '/article/example-page',
        redirectUrl: '/blog/example-page/',
      },
    ],
  },
  [ABTestEnum.ARTICLE_HEADER]: {
    id: 'article_side_by_side_header',
    control: 'control',
    variant: 'split_header',
  },
  [ABTestEnum.ARTICLE_HEADER_RELATED_LINKS]: {
    id: 'article_header_related_links',
    control: 'control',
    variant: 'header_related_links',
    paths: [
      // For testing on localnerd/stage
      '/article/credit-cards/step-by-step-kitchen-sink-2-2',

      // From https://docs.google.com/spreadsheets/d/1ehYtUKVs0_-PxePOnlTAdIWkrE9zTx5pByYaK0_bwwI/edit?usp=sharing
      '/article/finance/make-money-driving-amazon-flex',
      '/article/finance/best-time-to-buy-mattress',
      '/article/finance/getting-started-taskrabbit',
      '/article/finance/best-time-to-buy-plane-tickets',
      '/article/finance/budgeting-for-newlyweds',
      '/article/finance/budgeting-for-new-homeowners',
      '/article/finance/making-money-by-delivering-with-ubereats-what-to-expect',
      '/article/finance/how-to-save-for-a-car',
      '/article/finance/how-to-prepare-for-a-recession',
      '/article/finance/where-to-sell-your-clothes-online',
      '/article/finance/free-budget-spreadsheets-templates',
      '/article/finance/how-to-choose-the-right-budget-system',
      '/article/finance/surveys-for-money-site-reviews',
      '/article/travel/united-airlines-mileageplus-program-the-complete-guide',
      '/article/travel/southwest-rapid-rewards-complete-guide',
      '/article/travel/spirit-airlines-free-spirit',
      '/article/travel/alaska-airlines-mileage-plan-your-complete-guide',
      '/article/travel/american-airlines-aadvantage-complete-guide',
      '/article/travel/delta-air-lines-skymiles-program-the-complete-guide',
      '/article/travel/frontier-miles-the-complete-guide',
      '/article/travel/hawaiian-airlines-hawaiianmiles-the-complete-guide',
      '/article/travel/jetblue-trueblue-rewards-program-the-complete-guide',
      '/article/travel/ihg-rewards-more-value-for-the-frugal-traveler',
      '/article/travel/hilton-honors-complete-guide',
      '/article/travel/complete-guide-redeeming-united-mileageplus-miles',
      '/article/travel/top-10-beers-to-try-in-germany',
      '/article/travel/what-to-do-if-you-have-an-accident-in-a-rental-car',
      '/article/travel/marriott-bonvoy-program-the-complete-guide',
      '/article/travel/best-days-book-flight-fly',
      '/article/finance/debt',
      '/article/finance/7-tips-for-getting-an-apartment-without-credit',
      '/article/finance/what-makes-up-credit-score',
      '/article/finance/tips-for-lowering-credit-utilization',
      '/article/finance/how-to-build-credit',
      '/article/finance/tips-for-paying-off-debt-from-people-who-did-it',
      '/article/finance/find-extra-money-pay-debts',
      '/article/finance/chapter-7-bankruptcy',
      '/article/finance/how-does-debt-settlement-work',
      '/article/finance/find-debt-relief',
      '/article/finance/fair-debt-collection-practices-act',
      '/article/finance/pay-medical-debt',
      '/article/finance/credit-score-needed-to-buy-car',
      '/article/finance/credit-score-drop-pay-debt',
      '/article/finance/credit-score-improve-credit-card-paid-off',
      '/article/loans/student-loans/public-service-loan-forgiveness',
      '/article/loans/student-loans/student-loan-relief/',
      '/article/loans/student-loans/student-loan-repayment-plans',
      '/article/loans/personal-loans/ways-to-use-a-personal-loan',
      '/article/loans/payday-loans/alternatives-to-payday-loans-in-crisis',
      '/article/loans/personal-loans/unsecured-personal-loans-no-collateral',
      '/article/investing/mutual-funds-work',
      '/article/investing/what-is-an-etf',
      '/article/investing/investment-strategies',
      '/article/investing/safe-investments-low-risk-options',
      '/article/investing/brokerage-commissions-fees',
      '/article/taxes/how-to-fill-out-form-w4-guide',
      '/article/taxes/estate-tax ',
      '/article/taxes/avoid-irs-scams',
      '/article/taxes/fsa-hsa-taxes ',
      '/article/banking/money-orders',
      '/article/banking/small-business-checking-primer',
      '/article/banking/ach-transfers',
      '/article/banking/faq-money-market-account',
      '/article/banking/wire-transfers-what-banks-charge',
      '/article/banking/4-ways-to-earn-more-interest-on-savings',
      '/article/banking/cashiers-check-when-you-need-one-how-to-get-it',
      '/article/banking/how-to-open-a-bank-account-what-you-need',
      '/article/insurance/variable-life-insurance',
      '/article/insurance/universal-life-insurance',
      '/article/insurance/guaranteed-issue-life-insurance',
      '/article/insurance/life-insurance-coronavirus-faq',
      '/article/insurance/indexed-universal-life-insurance',
      '/article/insurance/senior-life-insurance',
      '/article/insurance/indexed-universal-life-insurance',
      '/article/insurance/cheapest-car-insurance-in-wyoming-wy',
      '/article/insurance/cheapest-auto-insurance-tulsa-ok',
      '/article/insurance/cheapest-car-insurance-in-south-dakota-sd',
      '/article/insurance/car-asset-protection',
      '/article/insurance/car-insurance-policy-cancelled',
      '/article/insurance/cost-of-car-theft-insurance',
      '/article/credit-cards/benefits-delta-cards',
      '/article/credit-cards/credit-card-rewards-and-amazon',
      '/article/credit-cards/credit-card-bonus-malls',
      '/article/credit-cards/how-is-credit-card-interest-calculated',
      '/article/credit-cards/american-express-membership-rewards-review',
      '/article/credit-cards/best-credit-cards-for-airbnb',
      '/article/credit-cards/airline-credit-cards-companion-tickets',
      '/article/credit-cards/credit-card-rules-can-break-emergency',
      '/article/credit-cards/moving-recurring-credit-card-payments',
      '/article/credit-cards/visa-credit-card-benefits-levels-traditional-signature-infinite',
      '/article/credit-cards/credit-cards-merchant-category-codes-mcc-explained',
      '/article/credit-cards/credit-one-credit-cards-review',
      '/article/mortgages/the-20-mortgage-down-payment-is-dead',
      '/article/mortgages/should-you-make-biweekly-mortgage-payments ',
      '/article/mortgages/new-york-state-first-time-home-buyer-programs',
      '/article/mortgages/cost-to-build-deck',
      '/article/mortgages/how-to-increase-home-value',
      '/article/credit-cards/instant-credit-card-numbers',
      '/article/credit-cards/minimum-payment-credit-card/',
      '/article/credit-cards/credit-limit-increase',
      '/article/credit-cards/long-wait-credit-card-applications',
      '/article/credit-cards/credit-card-theft-fraud-serious-crime-penalty',
      '/article/loans/student-loans/student-loan-interest-rates',
      '/article/loans/student-loans/pay-off-student-loans-fast',
      '/article/loans/student-loans/average-salary-by-age',
      '/article/loans/student-loans/consolidate-student-loans',
      '/article/loans/student-loans/do-student-loans-affect-buying-a-house',
      '/article/loans/personal-loans/credit-union-loans-personal-often-cheaper',
      '/article/loans/personal-loans/no-credit-check-installment-loan',
      '/article/loans/personal-loans/personal-loan-affect-credit-score',
    ],
  },
};

export default config;

/**
 * Returns experiment name for a given url path
 *
 * @param String path to find experiment name for
 *
 * @return String name of the experiment from EXPERIMENTS object
 */
export const getExperimentNameForPath = (path: string): ABTestEnum =>
  Object.keys(config).find((key: ABTestEnum) => {
    const experimentUrls = _.get(config, [key, 'urls'], []);
    return experimentUrls.some((urlObj) => _.includes(urlObj, path));
  }) as ABTestEnum; // TODO: Why do I have to cast here?

export type Experiments = {
  availableExperiments: {
    [key: string]: {
      variantName: string;
    };
  };
};
export const getVariantForTest = (
  experimentName: string,
  experiments: Experiments,
  search: string
) => {
  const searchParams = new URLSearchParams(search);
  return (
    searchParams.get(`test_${experimentName}`) ||
    experiments?.availableExperiments?.[experimentName]?.variantName ||
    'control'
  );
};

/**
 * Returns an array of active experiments.
 * Filters for experiments active for a given article type and pathname
 */
export const getActiveExperiments = (args: {
  experiments: Experiments;
  location: Location;
  articleType: ArticleTypeEnum;
}) => {
  return getActiveExperimentsImpl({
    ...args,
    articleTypes: ARTICLE_TYPES,
    abTestConfig: config,
  });
};

export type ActiveExperiments = Array<{
  experiment: string;
  variant: string;
}>;

// exported for testing
const getActiveExperimentsImpl = ({
  experiments,
  location,
  articleType,
  articleTypes,
  abTestConfig,
}: {
  experiments: Experiments;
  location: Location;
  articleType: ArticleTypeEnum;
  articleTypes: ArticleTypes;
  abTestConfig: {
    [s in ABTestEnum]: AbExperiment;
  };
}) => {
  // get experiments for article type
  const abConfig = articleTypes[articleType]?.abTestConfig ?? [];

  const activeExperiments: ActiveExperiments = [];

  abConfig.forEach((configString) => {
    const configObj = abTestConfig[configString];
    // skip if experiment is restricted to paths and this article isn't one of them
    if (configObj.paths && !configObj.paths.includes(location.pathname)) return;
    activeExperiments.push({
      experiment: configObj.id,
      variant: getVariantForTest(configObj.id, experiments, location.search),
    });
  });

  return activeExperiments;
};

export const experiments = Object.keys(config).map((testConstant) =>
  _.get(config, [testConstant, 'id'])
);

// eslint-disable-next-line no-underscore-dangle
export const __testing = {
  getActiveExperimentsImpl,
};
